import { LoadingButtonProps as MuiLoadingButtonProps } from '@mui/lab';
import { Button as MuiLoadingButton } from '@mui/material';
import { SxProps, Theme } from '@mui/material/styles';
import { FC } from 'react';
import LoadingIndicator from '../LoadingIndicator/LoadingIndicator';

interface LoadingButtonProps extends MuiLoadingButtonProps { sx?: SxProps<Theme> }

const LoadingButton: FC<LoadingButtonProps> = ({ children, sx = [], ...props }) => {
  return (
    <MuiLoadingButton
      {...props}
      variant='outlined'
      loadingIndicator={<LoadingIndicator thickness={3} size={24} loading={props.loading ?? true}/>}
      sx={[
        (theme) => ({
          fontFamily: theme.typography.primaryFont,
          border: '2px solid',
          borderRadius: 0,
          letterSpacing: '0.1em',
          fontSize: '14px',
          padding: '10px, 20px',
          fontWeight: 700,
          color: 'black',
          backgroundColor: 'white',
          minWidth: 'fit-content',
          borderColor: theme.colors.primary,
          '&:hover': {
            border: '2px solid',
            backgroundColor: 'white',
            borderColor: theme.colors.primary
          },
          '&.Mui-disabled': {
            border: '2px solid'
          }
        }),
        ...(Array.isArray(sx) ? sx : [sx])
      ]}>
      {children}
    </MuiLoadingButton>
  )
}

export default LoadingButton;
